import script from "./PdButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PdButton.vue?vue&type=script&setup=true&lang=js"

import "./PdButton.vue?vue&type=style&index=0&id=4dee2e36&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dee2e36"]])

export default __exports__